import * as angular from "angular";
import { CanvassService } from "../services/canvass.service";

export class CanvassDataProvider {
    public count: undefined | number = undefined;
    public canvasses: object[] = [];
    private infiniteItems: CanvassDataInfiniteItems;

    private filters: any = {};
    private locationCanvassId: string | number = null;
    private searchPromise: any;

    private $q: any;
    private $http: any;
    private __env: any;

    private canvassService: CanvassService;

    constructor(
        $q: any,
        $http: any,
        CanvassService: CanvassService,
        __env: any
    ) {
        this.$q = $q;
        this.$http = $http;
        this.__env = __env;

        this.canvassService = CanvassService;

        this.infiniteItems = new CanvassDataInfiniteItems(this);
    }

    clearAll(): void {
        this.filters = {};
        this.searchPromise = null;
        this.canvasses = [];
        this.infiniteItems.reset();
        this.count = undefined;
    }

    setLocationId(id: string | number): void {
        this.locationCanvassId = id;
        this.clearAll();
    }

    getFilters(): any {
        return this.filters;
    }

    setFilters(setFilters: object): void {
        this.filters = setFilters;
        this.infiniteItems.reset();
        this.canvasses.splice(0, this.canvasses.length);
    }

    removeActivity(activity: object): void {
        this.canvasses.splice(this.canvasses.indexOf(activity), 1);
        this.infiniteItems.numLoaded_ -= 1;
    }

    getAllUserCanvasses(filter: any, offset?: any): Promise<any> {
        const deferred = this.$q.defer();
        let effortID =
            filter.effort && filter.effort.values && filter.effort.values.id
                ? filter.effort.values.id
                : null;
        const startDate = filter.startDate.values ?? null;
        const endDate = filter.endDate.values ?? null;
        filter = filter.nonEmptyValues();
        filter.effort = effortID;
        filter.startDate = startDate;
        filter.endDate = endDate;

        this.canvassService.user({ filter: filter, offset: offset }).then(
            (response) => {
                const json = response["data"];
                deferred.resolve(json.data);
            },
            (error) => {
                deferred.reject(error);
            }
        );

        return deferred.promise;
    }

    getCanvassCount(): number | undefined {
        return this.count;
    }

    getCanvasses(offset: any): Promise<any> {
        const deferred = this.$q.defer();
        let filters = this.getFilters();
        if (this.searchPromise) this.searchPromise.resolve("user cancelled");
        this.searchPromise = this.$q.defer();
        if (filters) {
            filters = filters.nonEmptyValues();
        }
        this.$http({
            url: "/v2/event/canvasses/" + this.locationCanvassId,
            method: "GET",
            params: {
                filters: JSON.stringify(filters),
                offset: offset,
            },
            timeout: this.searchPromise.promise,
        }).then(
            (response: object) => deferred.resolve(response["data"]),
            (error) => deferred.reject(error)
        );
        return deferred.promise;
    }
}

export class CanvassDataInfiniteItems {
    public numLoaded_ = 0;
    public toLoad_ = 0;
    public loading = true;
    public end = false;
    public dataProvider: CanvassDataProvider;

    constructor(dataProvider: CanvassDataProvider) {
        this.dataProvider = dataProvider;
    }

    getItemAtIndex(index: number): any {
        if (index > this.numLoaded_ - 1) {
            this.fetchMoreItems_(index);
            return null;
        }
        return this.dataProvider.canvasses[index];
    }

    // For infinite scroll behavior, we always return a slightly higher
    // number than the previously loaded items.
    getLength(): number {
        let count = this.dataProvider.getCanvassCount();
        if (angular.isDefined(count) && this.numLoaded_ + 10 > count)
            return count;
        return this.numLoaded_ + 10;
    }

    fetchMoreItems_(index: number): void {
        if (this.toLoad_ < index) {
            this.loading = true;
            this.toLoad_ += 50;

            this.dataProvider.getCanvasses(this.numLoaded_).then((json) => {
                let canvassData = json.data;
                if (json.meta && json.meta.count) {
                    this.dataProvider.count = parseInt(json.meta.count);
                }
                this.dataProvider.canvasses =
                    this.dataProvider.canvasses.concat(canvassData);
                if (
                    this.dataProvider.count ===
                        this.dataProvider.canvasses.length ||
                    canvassData.length < 50
                ) {
                    this.end = true; //no more canvass to load.
                }
                this.numLoaded_ = this.dataProvider.canvasses.length;
                this.loading = false;
            });
        }
    }

    reset(): void {
        this.numLoaded_ = 0;
        this.toLoad_ = 0;
        this.end = false;
    }
}

angular
    .module("vcDataProvider")
    .service("CanvassDataProvider", CanvassDataProvider);
